import styled from "styled-components";

export const SubcompanyTableWrapper = styled.div`
    .ant-table-thead {
        background: #f5f5f5 !important;
    }
    .ant-table-thead > tr > th {
        background: none;
    }

    .ant-table-expanded-row > td {
        padding: 0 !important;
        background-color: transparent !important;
    }

    .ant-table-expanded-row > td > .ant-table-expanded-row-fixed {
        padding: 0 !important;
        margin: 0 !important;
    }

    .ant-table-row {
        cursor: pointer;
    }
`;

export const DaysContainer = styled.div`
    padding: 0;
    background: transparent !important;
`;

export const DayWrapper = styled.div`
    background: #d4d4d4;
    padding: 12px;

    & + & {
        padding-top: 0;
    }
`;

export const DayRow = styled.div`
    display: flex;
    align-items: center;
    padding: 12px;
    cursor: pointer;
    background: #ffffff;
`;

export const DayIcon = styled.div`
    width: 32px;
    height: 32px;
    background-color: rgb(126 126 126);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-right: 12px;
    font-size: 16px;
`;

export const DayInfo = styled.div`
    flex: 1;
    font-weight: 500;
    font-size: 14px;
    color: #333;
`;

export const DayTotal = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    .label {
        color: #888;
        font-size: 13px;
    }

    .amount {
        font-weight: 600;
        font-size: 14px;
        color: #333;
    }

    .arrow {
        margin-left: 8px;
        color: #999;
        font-size: 12px;
    }
`;

export const ExpandedDayContent = styled.div`
    padding: 12px 16px;
    background-color: #d1daf2 !important;
`;

export const DayTransactionTableWrapper = styled.div`
    margin-bottom: 12px;

    .ant-table {
        border-radius: 0 !important;
    }

    .ant-table-container {
        border-radius: 0 !important;
    }

    .ant-table-thead {
        background: rgb(250, 250, 250) !important;
    }

    .ant-table-thead > tr > th {
        background: rgb(250, 250, 250) !important;
    }

    .ant-table-thead > tr > th:last-child {
        border-right: none !important;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
        background: #fff !important;
    }
`;

export const CourierBox = styled.div`
    overflow: hidden;
    transition: box-shadow 0.2s;

    & + & {
        border-top: 2px solid #d5d5d5;
    }

    &:hover {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    }
`;

export const CourierHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    background: #fff;
    transition: background-color 0.2s;

    & + & {
        border-top: 2px solid #d5d5d5;
    }

    &:hover {
        background-color: #fafafa;
    }
`;

export const CourierName = styled.span`
    font-weight: 600;
    font-size: 14px;
    color: #333;
`;

export const CourierTotal = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    .amount {
        font-weight: 600;
        font-size: 14px;
        color: #333;
    }

    .arrow {
        color: #999;
        font-size: 12px;
    }
`;

export const CourierContent = styled.div`
    .ant-table {
        border-radius: 0 !important;
    }

    .ant-table-container {
        border-radius: 0 !important;
    }

    .ant-table-thead {
        background: rgb(250, 250, 250) !important;
    }

    .ant-table-thead > tr > th {
        background: rgb(250, 250, 250) !important;
    }

    .ant-table-thead > tr > th:last-child {
        border-right: none !important;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
        background: #fff !important;
    }

    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: #f5faf5 !important;
    }
`;

export const GreenText = styled.span`
    color: #27ae60;
    font-weight: 500;
`;

export const RedText = styled.span`
    color: #e74c3c;
    font-weight: 500;
`;

export const StatsGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 24px;
`;

export const StatCard = styled.div`
    flex: 1 1 140px;
    min-width: 140px;
    max-width: 200px;
    padding: 16px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

export const StatIconWrapper = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
    color: ${({$highlight}) => ($highlight ? "#faad14" : "#333")};
    background: ${({$highlight}) => ($highlight ? "#fffbe6" : "transparent")};
`;

export const StatContent = styled.div`
    flex: 1;
    min-width: 0;
    text-align: center;
`;

export const StatValue = styled.div`
    font-weight: 600;
    font-size: 18px;
    color: #333;
    line-height: 1.3;
`;

export const StatLabel = styled.div`
    font-size: 13px;
    color: #666;
    margin-top: 4px;
`;
